import createNotification from './component.js';

export default (arMsg) => {
  arMsg.forEach(createNotification);
};
